import { apiClient } from '@/shared/api/apiClient';
import { handleRequest } from '@/shared/api/apiWrapper';
import {
  type UserProfileInfoResponseDto,
  type UserProfileSettingsRequestDto,
  type UserScopeConfigurationResponseDto,
} from './types';

export const getUserProfileInfo = async () => {
  const request = () => apiClient.get('/users/profile/info');
  const response = await handleRequest<UserProfileInfoResponseDto>(request);
  return response.data;
};

export const getUserScopeConfiguration = async () => {
  const request = () => apiClient.get('/users/scope/configuration');
  const response =
    await handleRequest<UserScopeConfigurationResponseDto>(request);
  return response.data;
};

export const updateUserProfileSettings = async (
  dto: UserProfileSettingsRequestDto
) => {
  const request = () => apiClient.put('/users/profile/settings', dto);
  const response = await handleRequest<void>(request);
  return response.data;
};
